import { MX } from "./environment";

export const endpoints = {
  notifications: MX.notificationServiceBaseURL + "/notification",
  comments: MX.notificationServiceBaseURL + "/comments",
  notificationComments: MX.notificationServiceBaseURL + "/comments/notification",
  notificationAuditLogs: MX.notificationServiceBaseURL + "/notification/audit-logs",
  getCommentByNotificationId:
    MX.notificationServiceBaseURL + "/comments/{notification_id}",
  getCSRFToken: MX.notificationServiceBaseURL + "/csrf-token",
  filters: MX.notificationServiceBaseURL + "/filters",
  filtersCodesetLookup: MX.notificationServiceBaseURL + "/codeset-lookup",
  userSettings: MX.notificationServiceBaseURL + "/user-settings",
  panels: MX.notificationServiceBaseURL + "/user-settings/panels",
  downloadCSV: MX.notificationServiceBaseURL + "/notification/download-csv",
  getNotificationsHasUpdate:
    MX.notificationServiceBaseURL + "/notification/has/updates",
  updateNotificationReadUnread:
    MX.notificationServiceBaseURL + "/notification-read",
  logout: MX.notificationServiceBaseURL + "/users/logout",
  updateNotifications: MX.notificationServiceBaseURL + "/notification/update-notifications",
  defaultFilter: MX.notificationServiceBaseURL + "/user-settings/defaultFilter",
  removeNotificationFromUserView: MX.notificationServiceBaseURL + "/notification/remove-notification-from-user-view"
};
